import { createApp } from 'vue'
import App from '@/app/App.vue'
import router from '@/app/providers/router'
import directives from '@/app/providers/directives'
import UIComponents from '@/shared/ui'
import UIBaseComponents from '@/components/base'
import '@/shared/assets/tailwind.scss'
import '@/shared/lib/Prototypes'
import i18n from "@/translate"
import { VueQueryPlugin } from 'vue-query'
import { createVCodeBlock } from '@wdns/vue-code-block';
import { createPinia } from 'pinia'
// Vuetify
import vuetify from './plugins/vuetify'

import Maska from 'maska'

import { http_client } from '@/plugins/httpClient'
import { backendPath } from '@/app.config'
// @ts-ignore
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

const VCodeBlock = createVCodeBlock({
    // options
});

const pinia = createPinia()

const app = createApp(App)

UIComponents.forEach(UIComponent => {
    if (UIComponent.name) {
        app.component(UIComponent.name, UIComponent);
    }
});

UIBaseComponents.forEach(UIComponent => {
    if (UIComponent.name) {
        app.component(UIComponent.name, UIComponent);
    }
});

if (process.env.NODE_ENV !== 'production') {
    // Отключение всех предупреждений Vue
    app.config.warnHandler = () => {};
}

directives.forEach(directive => {
    app.directive(directive.name, directive);
});

app.use(VueQueryPlugin)

app.use(VCodeBlock);

// @ts-ignore
// Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)
app.use(router)

app.use(pinia)
app.use(vuetify)

app.use(http_client, {
	baseUrl: `${process.env.NODE_ENV !== 'production' ? 'https://dev.doc.doriclub.uz' : 'https://dev.doc.doriclub.uz'}/${backendPath}`,
})

app.use(VuePlyr)
app.component('QuillEditor', QuillEditor);
app.use(Maska)

app.use(i18n)
app.mount('#app')
